export class App {
    'name';
    'paths';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "paths",
            "baseName": "paths",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return App.attributeTypeMap;
    }
    constructor() {
    }
}
